<!-- Main navbar -->
<div class="navbar navbar-dark navbar-static py-2">
	<div class="container-fluid">
		<div class="navbar-brand">
			<a href="index.html" class="d-inline-flex align-items-center">
				<img src="images/iit-madras-logo.png" alt="MANGO Logo" 
					style="width: 50px; height: 50px; border-radius: 50%; background-color: #ffffff; padding: 5px; box-sizing: border-box; object-fit: contain; border: 3px solid #ff6b35;">
				<img src="images/logo_text_light.svg" class="d-none d-sm-inline-block h-16px ms-3" alt="">
			</a>
		</div>

		<div class="d-flex justify-content-end align-items-center ms-auto">
			<ul class="navbar-nav flex-row">
				<li class="nav-item">
					<a href="/login" class="navbar-nav-link navbar-nav-link-icon rounded ms-1">
						<div class="d-flex align-items-center mx-md-1">
						<i class="ph-user-circle"></i>
						<span class="d-none d-md-inline-block ms-2">Login</span>
					</div>
					</a>
				</li>
			</ul>
		</div>
	</div>
</div>
<!-- /main navbar -->

<!-- Page content -->
<div class="page-content bg-dark">

	<!-- Main content -->
	<div class="content-wrapper">

		<!-- Inner content -->
		<div class="content-inner">

			<!-- Content area -->
			<div class="content d-flex justify-content-center align-items-center">
				<div class="card shadow-sm p-4 w-100 mx-auto">
				  <div class="text-center mb-4">
					<!-- <img src="images/iit-madras-logo.png" class="h-80px" alt="MANGO Logo" class="logo-circle"> -->
					<img src="images/iit-madras-logo1.png" class="h-80px logo-circle" alt="MANGO Logo">
				</div>
				  <h2 class="text-center mb-4">Registration Form</h2>
				  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
					<div class="row">
					  <!-- Username -->
					  <!-- <div class="col-md-6 mb-3">
						<label class="form-label">Username</label>
						<input type="text" class="form-control" formControlName="username" [class.is-invalid]="isInvalid('username')">
						<div class="invalid-feedback" *ngIf="isInvalid('username')">
						  <small *ngIf="hasError('username', 'required')">Username is required.</small>
						  <small *ngIf="hasError('username', 'minlength')">Min 4 characters.</small>
						  <small *ngIf="hasError('username', 'pattern')">No spaces or symbols allowed.</small>
						</div>
					  </div> -->
			  
					  <!-- Email -->
					  <div class="col-md-12 mb-3">
						<label class="form-label">Email<span class="text-danger">*</span></label>
						<div class="input-group">  
							<input type="email" class="form-control" placeholder="Enter Email ID" formControlName="email" appLowercaseInput [class.is-invalid]="isInvalid('email')">
							<div class="invalid-feedback" *ngIf="isInvalid('email')">
								<small *ngIf="hasError('email', 'required')">Email is required.</small>
								<small *ngIf="hasError('email', 'pattern')">Invalid email format.</small>
							  </div>
						</div>
					  </div>
			  
					  <!-- First Name -->
					  <div class="col-md-6 mb-3">
						<label class="form-label">First Name<span class="text-danger">*</span></label>
						<input type="text" class="form-control" placeholder="Enter First Name" formControlName="first_name" [class.is-invalid]="isInvalid('first_name')">
						<div class="invalid-feedback" *ngIf="isInvalid('first_name')">
						  <small *ngIf="hasError('first_name', 'required')">First name is required.</small>
						  <small *ngIf="hasError('first_name', 'pattern')">Only alphabets allowed.</small>
						</div>
					  </div>
			  
					  <!-- Last Name -->
					  <div class="col-md-6 mb-3">
						<label class="form-label">Last Name<span class="text-danger">*</span></label>
						<input type="text" class="form-control" placeholder="Enter Last Name" formControlName="last_name" [class.is-invalid]="isInvalid('last_name')">
						<div class="invalid-feedback" *ngIf="isInvalid('last_name')">
						  <small *ngIf="hasError('last_name', 'required')">Last name is required.</small>
						  <small *ngIf="hasError('last_name', 'pattern')">Only alphabets allowed.</small>
						</div>
					  </div>
			  
					  <!-- Password -->
					  <div class="col-md-6 mb-3">
						<label class="form-label">Password<span class="text-danger">*</span></label>
						<input type="password" class="form-control" placeholder="Enter Password" formControlName="password" [class.is-invalid]="isInvalid('password')">
						<div class="invalid-feedback" *ngIf="isInvalid('password')">
						  <small *ngIf="hasError('password', 'required')">Password is required.</small>
						  <small *ngIf="hasError('password', 'minlength')">Min 8 characters.</small>
						  <small *ngIf="hasError('password', 'pattern')">No spaces allowed.</small>
						</div>
					  </div>
			  
					  <!-- Confirm Password -->
					  <div class="col-md-6 mb-3">
						<label class="form-label">Confirm Password<span class="text-danger">*</span></label>
						<input type="password" class="form-control" placeholder="Enter Confirm Password" formControlName="password_confirmation" [class.is-invalid]="isInvalid('password_confirmation')">
						<div class="invalid-feedback" *ngIf="isInvalid('password_confirmation')">
						  <small *ngIf="hasError('password_confirmation', 'required')">Confirm Password is required.</small>
						  <small *ngIf="hasError('password_confirmation', 'mustMatch')">Passwords do not match.</small>
						</div>
					  </div>
					</div>
			  
					<!-- Submit Button -->
					<button type="submit" class="btn btn-primary w-100" [disabled]="form.invalid">Register</button>
				  </form>
				</div>
			  </div>
			  
			<!-- /content area -->


			<!-- Footer -->
			<!-- /footer -->

		</div>
		<!-- /inner content -->

	</div>
	<!-- /main content -->

</div>
<!-- /page content -->